module.exports = __webpack_public_path__ + "img/map_logo-Copy.d6497096.png";